import { Button, Divider, Group, Modal, Text } from '@mantine/core';
import { useEffect, useRef, useState } from 'react';
import getErrorMessage from '../../helpers/getErrorMessage';

// onDone refreshes the list, which unmounts this dialog while the request is still settling.
const TransitionConfirm = ({ confirm, onClose, onDone }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  const run = () => {
    setLoading(true);
    setError(null);
    confirm
      .action()
      // Closing the dialog is onDone's job, so a mounted guard here would leave it open in every
      // ordering where the refetch has not unmounted it first.
      .then(() => onDone())
      .catch((err) => {
        if (mounted.current) setError(getErrorMessage(err, 'The connector could not be moved.'));
      })
      .finally(() => {
        if (mounted.current) setLoading(false);
      });
  };

  return (
    <Modal opened onClose={onClose} title={confirm.title} size="md" centered>
      <Text size="sm">{confirm.body}</Text>
      {confirm.note && (
        <Text fz={12} c="dimmed" mt={8}>
          {confirm.note}
        </Text>
      )}
      {error && (
        <Text size="sm" c="danger" mt={8}>
          {error}
        </Text>
      )}
      <Divider my="md" />
      <Group justify="flex-end" gap={8}>
        <Button size="sm" variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button size="sm" color={confirm.color} loading={loading} onClick={run}>
          {confirm.cta}
        </Button>
      </Group>
    </Modal>
  );
};

export default TransitionConfirm;
